import { Modal, Col } from "antd";
import { Flex, Box } from "@chakra-ui/react";
import OutlineButton from "components/Button/OutlineButton";
import PrimaryButton from "components/Button/PrimaryButton";
import { useForm } from "react-hook-form";
import Field from "components/Input/Field/index";
import useSaveParametroPrevisaoOrcamentaria from "core/features/previsao-orcamentaria/hooks/useSaveParametroPrevisaoOrcamentaria ";
import { showSuccess, showErrorAxios } from "infra/helpers/alerta";
import { PrevisaoOrcamentrariaParametros } from "core/features/previsao-orcamentaria/typings/index";
import { useLoading } from "ui/components/GlobalLoading";
import usePrevisaoOrcamentariaParametro from "core/features/previsao-orcamentaria/hooks/usePrevisaoOrcamentariaParametro";
import { useEffect } from "react";
import { useInvalidateQuery } from "infra/packages/react-query";

interface ModalParametroPrevisaoOrcamentariaProps {
  onClose: () => void;
  visible: boolean;
}

export default function ModalParametroPrevisaoOrcamentaria({
  onClose,
  visible,
}: ModalParametroPrevisaoOrcamentariaProps) {
  const { doInvalidateQueryWithStringKey } = useInvalidateQuery();

  const {
    data,
    isLoading: isLoadingParametro,
    isFetching,
  } = usePrevisaoOrcamentariaParametro();

  const { mutate: saveParametro, isLoading } =
    useSaveParametroPrevisaoOrcamentaria();

  const { control, handleSubmit, reset } =
    useForm<PrevisaoOrcamentrariaParametros>({});

  const onSubmit = async (data: PrevisaoOrcamentrariaParametros) => {
    saveParametro(data, {
      onSuccess: () => {
        doInvalidateQueryWithStringKey("/v1/previsao-orcamentaria/parametros");
        onClose();
        showSuccess();
      },
      onError: (e) => {
        showErrorAxios(e);
      },
    });
  };

  useEffect(() => {
    if (data) {
      reset({
        indiceMedioInadimplencia: data.indiceMedioInadimplencia,
      });
    }
  }, [data, reset]);

  useLoading(isLoading);

  return (
    <Modal
      centered
      destroyOnClose
      width="500px"
      visible={visible}
      onCancel={onClose}
      title="Parâmetros"
      footer={
        <Flex flex={1} justify="end" gap={4}>
          <OutlineButton onClick={onClose}>Fechar</OutlineButton>
          <PrimaryButton
            onClick={() => handleSubmit(onSubmit)()}
            isLoading={isLoadingParametro || isFetching}
          >
            Salvar
          </PrimaryButton>
        </Flex>
      }
    >
      <form onSubmit={(ev) => handleSubmit(onSubmit)(ev)}>
        <Box as={Col} sm={24} mb={4}>
          <Field
            label="Índice médio de inadimplência"
            control={control}
            name="indiceMedioInadimplencia"
            rules={{
              required: "Campo obrigatório",
            }}
          />
        </Box>
      </form>
    </Modal>
  );
}
